import useBuilderStore from "@tool/store/useBuilderStore";
import useBuilderLocalStorage from "@tool/Builder/helpers/useBuilderLocalStorage";
import {DemoTemplates} from "../helpers/BuilderDemoData";

export default function BuilderInitGuest(): void {

    const builderLocalStorage = useBuilderLocalStorage();

    const {project, projectUrls, projectParameters, projectTemplates, projectBuilderSettings, builderStats} = useBuilderStore();

    project.value = null;

    projectUrls.value = builderLocalStorage.getUrls();
    projectParameters.value = builderLocalStorage.getParameters();
    projectTemplates.value = DemoTemplates;
    projectBuilderSettings.value = builderLocalStorage.getBuilderSettings();

    const storageBuilderStats = builderLocalStorage.getBuilderStats();
    storageBuilderStats.visits = storageBuilderStats.visits + 1;
    builderLocalStorage.updateBuilderStats(storageBuilderStats);

    builderStats.value = storageBuilderStats;

    console.log('init guest');

}